/**
 * THE brand theme — one place for the app's colours.
 *
 * The menu's teal (the Nexgensis BMR suite's drawer colour) is the brand:
 * every primary button, link, active tab, checkbox, focus ring, table header
 * and accent icon takes it from here. Change a value here and the whole app
 * follows — the antd theme (App.jsx) reads it directly, and the CSS custom
 * properties (--accent …, used by our own markup and Tailwind) are written
 * from it at start-up by applyBrand().
 *
 * styles/tokens.css keeps the same values only as a first-paint fallback.
 */
export const BRAND = {
  light: {
    primary: "#204448", //       buttons, links, active tabs, headers
    primaryHover: "#2f6066", //  hover / lighter accents
    primaryActive: "#163235", // pressed
    primaryBorder: "#87aeab", // soft borders, focus halos, logo gradient
    primarySoft: "#e6f0ef", //   tinted backgrounds (selected rows, chips)
    sider: "#204448", //         the menu drawer
    navSelectedBg: "#eff6ff", // selected menu row
    navSelectedFg: "#204448",
  },
  dark: {
    primary: "#5fb8ad",
    primaryHover: "#7fcbc1",
    primaryActive: "#3f9a8f",
    primaryBorder: "#a5dcd5",
    primarySoft: "rgba(95, 184, 173, 0.12)",
    sider: "#0f172a",
    navSelectedBg: "#1e293b",
    navSelectedFg: "#ffffff",
  },
};

export const brand = (mode) => (mode === "dark" ? BRAND.dark : BRAND.light);

/** Write the brand into the CSS custom properties our own markup reads. */
export function applyBrand(mode) {
  const b = brand(mode);
  const root = document.documentElement.style;
  root.setProperty("--accent", b.primary);
  root.setProperty("--accent-hover", b.primaryHover);
  root.setProperty("--accent-border", b.primaryBorder);
  root.setProperty("--accent-soft", b.primarySoft);
  root.setProperty("--sider-bg", b.sider);
  root.setProperty("--nav-selected-bg", b.navSelectedBg);
  root.setProperty("--nav-selected-fg", b.navSelectedFg);
  root.setProperty("--diag", mode === "dark" ? "rgba(95, 184, 173, 0.10)" : "rgba(32, 68, 72, 0.08)");
}
